import svg4everybody from 'svg4everybody';
import './_vendor/select2.min';
import './_vendor/swiper';
import './_vendor/jquery-validation';
import './_vendor/jquery.inputmask.bundle.min';
import './_vendor/jquery.fancybox.min';
import './_vendor/panzoom.min';
import '../../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';

svg4everybody();
